import React from "react";
import "../App.css";

const MobileScreen = () => {
    return (
        <div className="ms">
            <h3>WindowsL.nl is alleen beschikbaar op laptop/PC</h3>
        </div>
    );
};

export default MobileScreen;
